import React from 'react';
import PropTypes from 'prop-types';

const unveilCheck = (sheathId) => {
  const sheath = document.getElementById(sheathId);
  let width = 100;
  let interval;

  const start = () => {
    interval = setInterval(unveiling, 20);
  };
  const end = () => {
    clearInterval(interval);
  };

  const unveiling = () => {
    if (0 === width) {
      end();
    } else {
      const newWidth = width - 5;
      width = newWidth;
      sheath.style.width = newWidth + '%';
    }
  };
  start();
};

export class Checkbox extends React.Component {

  constructor (props) {
    super(props);

    this.state = {
      sheath: false,
      unveiled: false
    };

    this.onClick = this.onClick.bind(this);
  }

  componentDidUpdate (prevProps, prevState) {
    const { itemAction, checked, checkboxKey } = this.props;
    if (!checked && ('add' === itemAction)) {
      /* only unveil if sheath is actual there */
      const sheathId = 'check-sheath-' + checkboxKey;
      const sheath = document.getElementById(sheathId);
      if (sheath && (18 === sheath.offsetWidth)) {
        unveilCheck(sheathId);
      }
    }
  }

  onClick () {
    const { clickCB, callbackParams, checked, itemAction } = this.props;

    if ('add' === itemAction) {
      this.setState({ sheath: true, unveiled: false });
      setTimeout(() => {
        this.setState({ unveiled: true });
      }, 800);
    }

    setTimeout(() => {
      clickCB(!checked, callbackParams);
    },
    580); // time as long as animation runs for
  }

  render () {
    const { sheath, unveiled } = this.state;
    const { itemAction, checked, checkboxKey } = this.props;
    let icon;
    let showSheath;
    let divWrapperProps = {
      className: `${itemAction} select-checkbox-inner-wrap`
    };

    if (sheath && !unveiled) {
      divWrapperProps = {
        className: `${itemAction} select-checkbox-inner-wrap bg-teal-300`
      };
      showSheath = <div id={ `check-sheath-${checkboxKey}` } className="check-sheith"></div>;
      icon = <i className="icon-yes text-white" />;
    } else if (checked) {
      icon = <i className="icon-yes"/>;
    } else {
      icon = <i className="icon-plus"/>;
    }

    return (
      <div className={ `select-checkbox-wrap ${itemAction}` }
        key={ `checkbox-${checkboxKey}` }
        onClick={ this.onClick }
      >
        <div { ...divWrapperProps }>
          { showSheath }
          { icon }
        </div>
      </div>
    );
  }
}

Checkbox.propTypes = {
  itemAction: PropTypes.string, // "add" or "remove"
  clickCB: PropTypes.func,
  checked: PropTypes.bool,
  callbackParams: PropTypes.object,
  checkboxKey: PropTypes.string
};
